import React, {
  RefObject,
  useEffect,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  getCustomServicesData,
} from 'pages/Dashboard/pages/Billing/api';
import {
  customServicesColumns,
} from 'pages/Dashboard/pages/Billing/ChargeMaster/columns';
import {
  CustomChargeMasterDTO,
} from 'dtos';
import {
  normalizeCustomServicePrice,
} from 'pages/Dashboard/pages/Billing/helpers';

type Props = {
  searchQuery?: string;
  tableInstanceRef?: RefObject<VirtualTableInstance>;
};

export default function CustomServicesOverview({
  searchQuery = '',
  tableInstanceRef,
}: Props) {
  useEffect(() => {
    const unsubscribeFromChange = billingEventChannel.on('onPricesChanged', () => {
      tableInstanceRef?.current?.refetch?.();
    });

    return () => {
      unsubscribeFromChange();
    };
  }, []);

  return (
    <div className="flex flex-1 w-full h-full overflow-y-hidden">
      <Table<CustomChargeMasterDTO>
        instanceRef={tableInstanceRef}
        columns={customServicesColumns}
        defaultPagination={{
          pageSize: 25,
          pageIndex: 0,
        }}
        dataKey="custom-codes-table"
        getData={getCustomServicesData}
        queryParams={{ searchQuery }}
        onRowClick={(table, row) => {
          billingEventChannel.emit('onPriceDialogOpen', {
            price: normalizeCustomServicePrice(row.original),
            type: 1,
          });
        }}
        classes={{
          header: 'px-4',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
          row: '!items-start',
        }}
      />
    </div>
  );
}
